module.exports = __webpack_public_path__ + "img/testimonial-zeljko.f4ff4598.png";